import { memo, useCallback } from 'react';
import BottomDrawerSelect from 'src/components/Inputs/BottomDrawerSelect/BottomDrawerSelect';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { ScaledOrderSizeDistribution } from 'src/stores/VelocityStore/types/tradeForm';

const SIZE_DISTRIBUTION_OPTIONS: {
	label: string;
	value: ScaledOrderSizeDistribution;
}[] = [
	{ label: 'Flat', value: 'flat' },
	{ label: 'Ascending', value: 'ascending' },
	{ label: 'Descending', value: 'descending' },
];

function BottomDrawerSelectSizeDistribution() {
	const set = useVelocityStore((s) => s.set);
	const selectedSizeDistribution = useVelocityStore(
		(s) => s.tradeForm.scaledOrders.sizeDistribution
	);

	const handleSelect = useCallback(
		(sizeDistribution: ScaledOrderSizeDistribution) => {
			set((s) => {
				s.tradeForm.scaledOrders.sizeDistribution = sizeDistribution;
			});
		},
		[set]
	);

	return (
		<BottomDrawerSelect
			label="Distribution"
			triggerValue={selectedSizeDistribution ?? ''}
			options={SIZE_DISTRIBUTION_OPTIONS}
			onSelect={handleSelect}
			selectedValue={selectedSizeDistribution}
		/>
	);
}

export default memo(BottomDrawerSelectSizeDistribution);
